module.exports = __webpack_public_path__ + "static/media/sun.08dc7d38.png";